module.exports = "/_next/static/resources/wfw-square-960b62a6f92f83ab9e3c4b70e3d1f9dc.jpg";